/*
 * Copyright (c) 2024 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import { JSONable } from '@irian-ro/abstract-resource';
import { Column, ColumnsInterface } from '@irian-ro/util-table';

export class VehicleFuelCardVo extends JSONable {
  uuid = '';
  owner = '';
  vehicleUuid = '';

  @Column({
    header: 'delivery-app.vehicle.fuelCards.series'
  })
  series: string | null = null;

  @Column({
    header: 'delivery-app.vehicle.fuelCards.provider'
  })
  provider: string | null = null;

  static _columns: ColumnsInterface[] | undefined = undefined;
}
